<template>
  <div>
    <PageHeader title="จัดการคอร์สเรียน"></PageHeader>
    <b-container fluid="xl" class="pt-5">
      <div class="outer">
        <div class="inner bg-container pb-5">
          <CourseNavSteps />
          <b-overlay :show="false" variant="white">
            <Loading
              v-if="isLoading"
              class="mt-2 fixed-top"
              style="z-index: 999999"
            />
            <b-row class="mt-5 mb-5" align-h="between">
              <b-col lg="8" class="px-5">
                <h4 class="title-text">
                  ข้อมูลคอร์สเรียน
                  <span
                    v-if="isWannasorn"
                    :class="
                      courseInfo.courseOnlineType == 'ONLINE'
                        ? 'online-course-badge'
                        : courseInfo.courseOnlineType == 'TRIAL'
                        ? 'trial-course-badge'
                        : ''
                    "
                    >{{ courseType }}</span
                  >
                </h4>
                <b-row class="mt-4">
                  <b-col>
                    <TextInput
                      v-if="courseInfo"
                      id="course_name"
                      label="ชื่อคอร์สเรียน"
                      attribute="courseName"
                      description="ไม่เกิน 150 ตัวอักษร"
                      :value="courseInfo.courseName"
                      :isRequire="true"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <TextInput
                      v-if="courseInfo"
                      id="course_slug"
                      label="URLคอร์สเรียน"
                      attribute="courseSlug"
                      description="ไม่เกิน 150 ตัวอักษร"
                      :value="courseInfo.courseSlug"
                      :isRequire="true"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col col-md="6">
                    <TextInput
                      v-if="courseInfo"
                      id="course_code"
                      label="รหัสคอร์สเรียน"
                      attribute="courseCode"
                      description="กรุณากรอกเป็นภาษาอังกฤษ หรือตัวเลข"
                      :isRequire="false"
                      :value="courseInfo.courseCode"
                    />
                  </b-col>
                  <b-col col-md="6">
                    <OwnerSelector
                      label="ชื่อผู้สอน"
                      attribute="courseOwner"
                      :company="company"
                      :value="courseInfo.courseOwner.ownerId"
                    />
                  </b-col>
                </b-row>
                <b-row v-if="isWannasorn" class="mt-4">
                  <!-- ประเภทวิชา -->
                  <b-col col-md="6">
                    <CourseAcademicDropdownSelector
                      id="subject-type"
                      label="ประเภทวิชา"
                      attribute="st_id"
                      :value="courseInfo.subjectId"
                      :options="courseAcademic.subjects"
                      optionLabel="st_name"
                    />
                  </b-col>
                  <!-- ระดับชั้นเรียน -->
                  <b-col col-md="6">
                    <CourseAcademicDropdownSelector
                      id="class-level"
                      label="ระดับชั้นเรียน"
                      attribute="acl_id"
                      :value="courseInfo.academyLevelId"
                      :options="courseAcademic.levels"
                      optionLabel="acl_name"
                    />
                  </b-col>
                </b-row>
                <b-row v-if="isWannasorn" class="mt-4">
                  <!-- ภาคการศึกษา -->
                  <b-col cols="6">
                    <CourseAcademicDropdownSelector
                      id="semester"
                      label="ภาคการศึกษา"
                      attribute="act_id"
                      :value="courseInfo.academyTypeId"
                      :options="courseAcademic.terms"
                      optionLabel="act_name"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <TextInput
                      id="course_short_description"
                      label="คำอธิบายสั้น ๆ"
                      description="ไม่เกิน 250 ตัวอักษร"
                      attribute="courseShortDescription"
                      :value="courseInfo.courseShortDescription"
                      :isRequire="true"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <TextEditor
                      id="course_description"
                      label="รายละเอียดคอร์ส"
                      attribute="courseDescription"
                      :value="courseInfo.courseDescription"
                    />
                  </b-col>
                </b-row>
                <!-- จำนวนผู้สมัครเรียน -->
                <b-row v-if="comId == 513" class="mt-4">
                  <b-col>
                    <p class="pb-2">วันที่เริ่มหลักสูตร</p>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="formattedstartLearningDate"
                        type="text"
                        placeholder="เลือกวันที่"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="startLearningDate"
                          button-only
                          right
                          locale="th"
                          @input="
                            editCourseInfo({
                              startLearningDate: startLearningDate,
                            })
                          "
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <ApplicantLimitForm />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <DifficultLevelForm attribute="courseDifficultLevel" />
                  </b-col>
                  <b-col v-if="comId == 512" align="right">
                    <div>
                      <label class="d-block">
                        รูปแบบของคอร์สเรียน
                      </label>
                      <div style="display:inline-block">
                        <div>
                          <span
                            class="mt-2 mr-2"
                            :style="
                              getCourseTypeStyle(courseInfo.courseOnlineType)
                            "
                          >
                            {{
                              courseInfo.courseOnlineType == "ONLINE"
                                ? "คอร์สเรียนออนไลน์"
                                : courseInfo.courseOnlineType == "HYBRID"
                                ? "การเรียนแบบผสมผสาน"
                                : ""
                            }}
                          </span>
                          <b-dropdown
                            v-if="courseInfo.courseOnlineType == 'ONLINE'"
                            right
                            size="sm"
                            variant="outline"
                            toggle-class="text-decoration-none"
                            no-caret
                          >
                            <template #button-content>
                              <i class="fas fa-ellipsis-v dropdown-icon"></i>
                            </template>
                            <b-dropdown-item @click="modalShowEditCourseType()">
                              เปลี่ยนคอร์สนี้เป็น
                              <span
                                style="color:white; background-color:#BA55D3;"
                                >การเรียนแบบผสมผสาน</span
                              >
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <DsdInfoForm
                  v-if="comId == 519"
                  :form="courseInfo"
                  :comId="comId"
                  :readonly="readonly"
                  class="mt-3"
                />
                <div v-if="isCompany([485])">
                  <TfacInfoForm class="mt-1" />
                </div>
                <div v-else-if="isCompany([519, 513])">
                  <AccountingInfoForm class="mt-1" :company="company" />
                  <div v-if="isCompany([513])">
                    <ManageCoursePriceAndLearnDuration />
                  </div>
                </div>
                <div v-else-if="isWannasorn">
                  <div v-if="courseInfo.courseOnlineType == 'TRIAL'">
                    <WannasornTrialCourseInfo />
                  </div>
                  <div v-else>
                    <WannasornCoursePrice />
                  </div>
                </div>
                <div v-else>
                  <div v-if="isCompany([500])">
                    <TibaInfoForm />
                  </div>
                  <ManageCoursePriceAndLearnDuration />
                </div>
              </b-col>
              <b-col lg="4" class="border-left px-4">
                <b-form-group
                  v-if="isWannasorn"
                  label-for="sub-company"
                  class="mt-4"
                >
                  <template v-slot:label>
                    <span>สถาบัน</span>
                    <span class="text-danger">*</span>
                  </template>
                  <v-select
                    id="sub-company"
                    v-model="selectedSubCompany"
                    :options="subCompanyOptions"
                    :reduce="function(opt) { return opt.scId }"
                    label="scName"
                    :clearable="false"
                    :disabled="subCompanyDisabled"
                    placeholder="เลือกสถาบัน"
                    @input="onSubCompanyChange"
                  ></v-select>
                </b-form-group>
                <label
                  id="fieldset-1__BV_label_"
                  for="duration"
                  class="d-block mt-4"
                >
                  รูปหน้าปกคอร์ส
                </label>
                <div
                  :class="[
                    { uploaded: courseAttributeUpdated['courseThumbnail'] },
                    'drop-zone',
                  ]"
                >
                  <b-overlay :show="onUploadCourseThumbnail" variant="white">
                    <b-media class="m-1">
                      <template v-slot:aside>
                        <b-img
                          :src="courseInfo.courseThumbnail"
                          height="50"
                          alt
                        />
                      </template>
                      <b-form-file
                        id="file"
                        ref="file"
                        v-model="courseThumbnail"
                        :state="Boolean(courseThumbnail)"
                        accept="Image/*"
                        :placeholder="
                          courseAttributeUpdated['courseThumbnail']
                            ? 'Uploaded'
                            : 'Choose / Drop file'
                        "
                        drop-placeholder="Drop file here..."
                        browse-text=" "
                        @input="upload"
                      ></b-form-file>
                    </b-media>
                  </b-overlay>
                </div>

                <!-- รูปตารางแพ็กเกจ -->
                <div
                  v-if="isWannasorn && courseInfo.courseOnlineType !== 'TRIAL'"
                >
                  <label
                    id="course-brochure"
                    for="course-brochure"
                    class="d-block mt-4"
                  >
                    รูปตารางแพ็กเกจ
                  </label>
                  <div
                    :class="[
                      { uploaded: courseAttributeUpdated['courseBrochure'] },
                      'drop-zone',
                    ]"
                  >
                    <b-overlay :show="onUploadCourseBrochure" variant="white">
                      <b-media class="m-1">
                        <template v-slot:aside>
                          <b-img
                            :src="courseInfo.courseBrochure"
                            height="50"
                            alt
                          />
                        </template>
                        <b-form-file
                          id="course-brochure-file"
                          ref="course-brochure-file"
                          v-model="courseBrochure"
                          :state="Boolean(courseBrochure)"
                          accept="Image/*"
                          :placeholder="
                            courseAttributeUpdated['courseBrochure']
                              ? 'Uploaded'
                              : 'Choose / Drop file'
                          "
                          drop-placeholder="Drop file here..."
                          browse-text=" "
                          @input="uploadCourseBrochureImage"
                        ></b-form-file>
                      </b-media>
                    </b-overlay>
                  </div>
                </div>

                <TagsForm />

                <TypeInsuranceForm
                  v-if="isCompany([470, 500, 503, 506, 502])"
                />
                <label
                  id="fieldset-1__BV_label_"
                  for="duration"
                  class="d-block mt-4"
                  >พรีวิวคอร์ส</label
                >
                <b-link
                  :href="
                    `${coursePreviewUrl}/${coursePreviewName}?preview=1&token=${token}`
                  "
                  target="_blank"
                  class="text-decoration-none"
                >
                  <TfacInfoCard
                    v-if="isCompany([485])"
                    :courseInfo="courseInfo"
                  />
                  <b-card
                    v-else
                    :img-src="courseInfo.courseThumbnail"
                    img-alt
                    img-top
                    style="max-width: 20rem"
                    no-body
                    footer-border-variant="white"
                    footer-bg-variant="white"
                    class="mb-4 text-dark"
                  >
                    <b-card-body>
                      <div class="my-2">
                        <b-badge
                          v-for="(tag, index) in courseInfo.courseTags"
                          :key="index"
                          variant="secondary"
                          class="mr-1"
                          >{{ tag.tagName }}</b-badge
                        >
                      </div>
                      <div class="course-title mt-2 text-crop-2">
                        {{ courseInfo.courseName }}
                      </div>
                      <b-card-text>
                        <a class="text-csq small">{{
                          courseInfo.courseOwner.ownerName
                        }}</a>
                      </b-card-text>
                    </b-card-body>
                    <template v-slot:footer>
                      <div v-if="company.id !== 519">
                        <h5
                          v-if="courseInfo.seasonPrice.enable === true"
                          class="text-right"
                        >
                          <span class="text-danger">
                            ฿{{ displayPrice() }}
                          </span>
                        </h5>
                        <h5
                          v-if="courseInfo.seasonPrice.enable === true"
                          class="float-right"
                        >
                          <del>
                            ฿{{
                              courseInfo.price
                                | formatNumber
                                | displaySeasonPrice
                            }}
                          </del>
                        </h5>
                        <h5 v-else class="float-right">
                          <span> ฿{{ displayPrice() }} </span>
                        </h5>
                      </div>
                      <div v-else>
                        <h5
                          class="text-right text-danger"
                          style="text-decoration: line-through;"
                        >
                          {{ dharmnitiFullPrice() }}
                        </h5>
                        <h5 class="text-right">
                          ฿{{ dharmnitiCoursePrice() }}
                        </h5>
                      </div>
                    </template>
                  </b-card>
                </b-link>

                <b-form-group
                  v-if="isWannasorn && courseInfo.courseOnlineType !== 'TRIAL'"
                  class="prerequisite-courses"
                  label="คอร์สที่ต้องเรียนก่อนหน้า"
                  label-for="prerequisite-courses"
                >
                  <b-form-tags
                    id="prerequisite-courses"
                    v-model="prerequisiteCourses"
                    no-outer-focus
                    class="mb-2"
                  >
                    <template v-slot="{ tags, disabled, addTag, removeTag }">
                      <ul
                        v-if="tags?.length > 0"
                        class="list-inline d-inline-block mb-2"
                      >
                        <li
                          v-for="tag in tags"
                          :key="tag"
                          class="list-inline-item"
                        >
                          <b-form-tag
                            @remove="onOptionRemove({ tag, removeTag })"
                            variant="info"
                          >
                            <p>{{ getCourseName(tag) }}</p>
                          </b-form-tag>
                        </li>
                      </ul>

                      <b-dropdown
                        size="sm"
                        variant="outline-secondary"
                        block
                        menu-class="w-100"
                      >
                        <template #button-content>
                          <b-icon icon="tag-fill"></b-icon> เลือกคอร์ส
                        </template>

                        <b-dropdown-item-button
                          v-for="option in availableCourses"
                          :key="option.courseId"
                          @click="
                            onOptionClick({ option: option.courseId, addTag })
                          "
                        >
                          {{ option.courseName }}
                        </b-dropdown-item-button>
                        <b-dropdown-text v-if="availableCourses.length === 0">
                          ไม่มีคอร์สให้เลือก
                        </b-dropdown-text>
                      </b-dropdown>
                    </template>
                  </b-form-tags>
                </b-form-group>
              </b-col>
            </b-row>
          </b-overlay>
          <CourseNavToolbar
            :sidebar-opened="sidebarOpened"
            :course="courseInfo"
            :company="company"
          />
        </div>
      </div>
    </b-container>
    <b-modal
      centered
      v-model="modalConfirmEditCourseType"
      size="lg"
      :hide-header="true"
      :hide-footer="true"
      ref="modal-delete-insurance-form"
    >
      <div>
        <ConfirmEditCourseType
          :courseName="courseInfo.courseName"
          :isConfirmed="isConfirmed"
          @modalHideEditCourseType="modalHideEditCourseType()"
          @edit="editCourseType($event)"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import CourseNavSteps from "./partials/CourseNavSteps";
import CourseNavToolbar from "./partials/CourseNavToolbar";
import TfacInfoCard from "./partials/TfacInfoCard";
import TfacInfoForm from "./forms/TfacInfoForm";
import TibaInfoForm from "./forms/TibaInfoForm";
import AccountingInfoForm from "./forms/AccountingInfoForm";
import TagsForm from "./forms/TagsForm";
import ConfirmEditCourseType from "./ConfirmEditCourseType.vue";
import TypeInsuranceForm from "./forms/TypeInsuranceForm";
import DifficultLevelForm from "./forms/DifficultLevelForm";
import ManageCoursePriceAndLearnDuration from "./forms/ManageCoursePriceAndLearnDurationForm.vue";
import WannasornCoursePrice from "./forms/WannasornCoursePriceAndLearnDurationForm.vue";
import WannasornTrialCourseInfo from "./forms/WannasornTrialCourseInfo.vue";
import ApplicantLimitForm from "./forms/ApplicantLimitForm.vue";
import TextInput from "./forms/TextInput";
import CourseAcademicDropdownSelector from "./forms/CourseAcademicDropdownSelector";
import OwnerSelector from "./forms/OwnerSelector";
import TextEditor from "./forms/TextEditor";
import courseMixin from "./../../../mixins/course-mixin.js";
import Loading from "../../shared/Loading";
import { mapActions, mapGetters } from "vuex";
import api from "@/services/api.js";
import Numeral from "numeral";
import DsdInfoForm from "./forms/DsdInfoForm.vue";
import authMixin from "@/mixins/auth-mixin.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "CourseInfoPage",
  components: {
    PageHeader,
    CourseNavSteps,
    CourseNavToolbar,
    TfacInfoCard,
    TfacInfoForm,
    TagsForm,
    DifficultLevelForm,
    ApplicantLimitForm,
    TextInput,
    CourseAcademicDropdownSelector,
    OwnerSelector,
    TextEditor,
    Loading,
    TibaInfoForm,
    TypeInsuranceForm,
    ConfirmEditCourseType,
    AccountingInfoForm,
    ManageCoursePriceAndLearnDuration,
    WannasornCoursePrice,
    WannasornTrialCourseInfo,
    DsdInfoForm,
    vSelect,
  },
  filters: {
    wordsCount: function(value) {
      if (value) {
        const cleanCode = value
          .replace(/<(?:.|\n)*?>/gm, "")
          .replace(/(\r\n|\n|\r)/gm, "")
          .replace("&nbsp;", "");

        return cleanCode.trim().length;
      }

      return 0;
    },
    formatNumber: function(value) {
      if (!isNaN(value)) {
        return Numeral(value).format("0,0");
      } else {
        return value;
      }
    },
    displaySeasonPrice: function(value) {
      if (value == 0 || value === null) {
        return "ฟรี";
      }
      return value;
    },
  },
  mixins: [courseMixin, authMixin],
  props: {
    user: { default: null, type: Object },
    company: { default: null, type: Object },
    sidebarOpened: Boolean,
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      courseId: this.$route.params.courseId,
      showCoursePriceModal: false,
      showCourseTfacPriceModal: false,
      onUploadCourseThumbnail: false,
      onUploadCourseBrochure: false,
      courseThumbnail: null,
      courseBrochure: null,
      token: localStorage.getItem("token"),
      isDropdownOpen: false,
      modalConfirmEditCourseType: false,
      isConfirmed: false,
      startLearningDate: "",
      prerequisiteCourses: [],
      selectedSubCompany: null,
      subCompanyOptions: [],
      subCompanyDisabled: false,
      subCompanyRequired: false,
      fetchParams: {
        company_id: null,
        page: null,
        limit: null,
        q: null,
        type: "ALL",
        sort_by: "updated",
        sort_order: "desc",
        excepts: "numberOfStudent,numberOfActiveStudent",
      },
    };
  },
  computed: {
    ...mapGetters("CourseManagement", [
      "isLoading",
      "courseInfo",
      "courseAcademic",
      "courseAttributeUpdated",
      "courseList",
    ]),
    invalidFeedback() {
      if (this.courseInfo.courseName.length > 4) {
        return "";
      } else if (this.courseInfo.courseName.length > 0) {
        return "Enter at least 4 characters";
      } else {
        return "Please enter something";
      }
    },
    validFeedback() {
      return this.state === true ? "Thank you" : "";
    },
    formattedstartLearningDate() {
      if (this.startLearningDate) {
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        return new Date(this.startLearningDate).toLocaleDateString(
          "th",
          options,
        );
      }
      return "";
    },
    courseType() {
      if (this.courseInfo.courseOnlineType == "ONLINE") {
        return "คอร์สเรียนปกติ";
      } else if (this.courseInfo.courseOnlineType == "TRIAL") {
        return "คอร์สทดลองเรียน";
      }
      return "";
    },
    availableCourses() {
      return this.courseList.data.filter(
        (course) =>
          !this.prerequisiteCourses?.includes(String(course.courseId)),
      );
    },
  },
  async created() {
    await api.get(
      `v1/members-role-permission/${this.$store.state.Authentication.authUser.id}`,
    );
    await this.getCourseInfo({
      courseId: this.courseId,
      temp: true,
      excepts: "numberOfStudent,numberOfActiveStudent",
    });
    await this.getCourseAcademic();
    await this.getCourseOnsiteInfo(this.courseId);

    this.fetchParams.company_id = this.comId;
    await this.fetchCourseList(this.fetchParams);
    let contentDiv = document.getElementById("content");
    contentDiv.scrollTop = 0;
    this.startLearningDate = this.courseInfo.startLearningDate;
    if (this.isWannasorn) {
      this.loadSubCompanyDropdown();
    }
  },
  methods: {
    ...mapActions("CourseManagement", [
      "getCourseInfo",
      "getCourseOnsiteInfo",
      "getCourseAcademic",
      "updateCourseInfo",
      "updateCourseTags",
      "uploadCourseThumbnail",
      "uploadCourseBrochure",
      "fetchCourseList",
    ]),
    isCompany(comIdArr) {
      return comIdArr.includes(this.company.id);
    },
    loadSubCompanyDropdown() {
      var self = this;
      var memberId = self.m_Id;
      var comId = self.comId;
      api
        .get("v1/companies/" + comId + "/members/" + memberId + "/sub-companies")
        .then(function (memberScRes) {
          var memberScData = memberScRes.data || [];
          var isCompanyWide = false;
          var memberSubCompanies = [];
          for (var i = 0; i < memberScData.length; i++) {
            if (memberScData[i].subCompanyId === null) {
              isCompanyWide = true;
            } else {
              memberSubCompanies.push({
                scId: memberScData[i].subCompanyId,
                scName: memberScData[i].subCompanyName,
              });
            }
          }
          if (isCompanyWide) {
            api
              .get("v1/companies/" + comId + "/sub-companies")
              .then(function (allScRes) {
                var allScData = allScRes.data.data || allScRes.data || [];
                var options = [{ scId: null, scName: "ทั้งหมด" }];
                for (var j = 0; j < allScData.length; j++) {
                  options.push({
                    scId: allScData[j].scId,
                    scName: allScData[j].scName,
                  });
                }
                self.subCompanyOptions = options;
                self.selectedSubCompany = self.courseInfo.scId;
                self.subCompanyRequired = false;
              });
          } else {
            self.subCompanyOptions = memberSubCompanies;
            self.subCompanyRequired = true;
            if (memberSubCompanies.length === 1) {
              self.selectedSubCompany = memberSubCompanies[0].scId;
              self.subCompanyDisabled = true;
              if (self.courseInfo.scId !== memberSubCompanies[0].scId) {
                self.editCourseInfo({ scId: memberSubCompanies[0].scId });
              }
            } else {
              self.selectedSubCompany = self.courseInfo.scId;
            }
          }
        });
    },
    onSubCompanyChange(value) {
      this.editCourseInfo({ scId: value });
    },
    getCourseName(val) {
      // Ensure courseList and data exist before searching
      if (!this.courseList?.data) return val;

      const course = this.courseList.data.find(
        (c) => String(c.courseId) === String(val), // Use String() to avoid type mismatch
      );

      return course ? course.courseName : val;
    },
    async onOptionClick({ option, addTag }) {
      const idAsString = String(option);
      await addTag(idAsString);
      this.editCourseInfo({ prerequisiteCourseId: this.prerequisiteCourses });
    },
    async onOptionRemove({ tag, removeTag }) {
      const idAsString = String(tag);
      await removeTag(idAsString);
      this.editCourseInfo({ prerequisiteCourseId: this.prerequisiteCourses });
    },
    getSearchKeyword(value) {
      console.log(value);
    },
    async editCourseInfo(attribute) {
      await this.updateCourseInfo({
        courseId: this.courseId,
        attribute: attribute,
      }).then(() => {
        this.getCourseInfo({
          courseId: this.courseId,
          temp: true,
          excepts: "numberOfStudent,numberOfActiveStudent",
        });
      });
    },
    async upload() {
      this.onUploadCourseThumbnail = true;
      await this.uploadCourseThumbnail({
        courseId: this.courseId,
        companyId: this.company.id,
        imageFile: this.courseThumbnail,
      }).then(() => {
        setTimeout(
          () =>
            this.getCourseInfo({
              courseId: this.courseId,
              temp: true,
              excepts: "numberOfStudent,numberOfActiveStudent",
            }),
          5000,
        );
        this.onUploadCourseThumbnail = false;
        this.updateCourseInfo({ courseId: this.courseId });
      });
    },
    async uploadCourseBrochureImage() {
      this.onUploadCourseBrochure = true;
      await this.uploadCourseBrochure({
        courseId: this.courseId,
        companyId: this.company.id,
        imageFile: this.courseBrochure,
      }).then(() => {
        setTimeout(
          () =>
            this.getCourseInfo({
              courseId: this.courseId,
              temp: true,
              excepts: "numberOfStudent,numberOfActiveStudent",
            }),
          1000,
        );
        this.onUploadCourseBrochure = false;
        this.updateCourseInfo({ courseId: this.courseId });
      });
    },
    displayPrice() {
      var price;
      if (
        this.courseInfo.membershipPrice.length > 0 &&
        this.courseInfo.membershipPrice[0].price != null &&
        Number(this.courseInfo.membershipPrice[0].price) <
          Number(this.courseInfo.price)
      ) {
        price = this.courseInfo.membershipPrice[0].price;
      } else if (
        this.courseInfo.seasonPrice.enable &&
        this.courseInfo.seasonPrice.price !== null &&
        Number(this.courseInfo.seasonPrice.price) <
          Number(this.courseInfo.price)
      ) {
        price = this.courseInfo.seasonPrice.price;
      } else if (
        this.courseInfo.promotionPrice !== null &&
        Number(this.courseInfo.promotionPrice) < Number(this.courseInfo.price)
      ) {
        price = this.courseInfo.promotionPrice;
      } else {
        price = this.courseInfo.price;
      }

      if (price > 0) {
        return Numeral(price).format("0,00");
      } else {
        return "ฟรี";
      }
    },
    dharmnitiCoursePrice() {
      var price;
      if (
        this.courseInfo.promotionPrice !== null &&
        Number(this.courseInfo.promotionPrice) < Number(this.courseInfo.price)
      ) {
        price = Number(this.courseInfo.promotionPrice) / 1.07;
      } else {
        price = Number(this.courseInfo.price) / 1.07;
      }

      if (price > 0) {
        return Numeral(price).format("0,00");
      } else {
        return "ฟรี";
      }
    },
    dharmnitiFullPrice() {
      var price;
      if (
        this.courseInfo.promotionPrice !== null &&
        Number(this.courseInfo.promotionPrice) <=
          Number(this.courseInfo.price) &&
        Number(this.courseInfo.promotionPrice) > 0
      ) {
        price = Number(this.courseInfo.price) / 1.07;
      } else {
        price = null;
      }

      if (price > 0) {
        return "฿" + Numeral(price).format("0,00");
      } else {
        return null;
      }
    },
    getCourseTypeStyle(typeName) {
      if (typeName === "ONLINE") {
        return {
          backgroundColor: "#F4A460",
          color: "white",
        };
      } else {
        return {
          backgroundColor: "#BA55D3",
          color: "white",
        };
      }
    },
    modalShowEditCourseType() {
      this.modalConfirmEditCourseType = true;
    },
    async modalHideEditCourseType() {
      this.modalConfirmEditCourseType = false;
      this.isConfirmed = false;
      await this.getCourseInfo({
        courseId: this.courseId,
        temp: true,
        excepts: "numberOfStudent,numberOfActiveStudent",
      });
    },
    async editCourseType(courseOnlineType) {
      await api
        .put(`/v1/courses/` + this.courseInfo.courseId + `/type`, {
          courseOnlineType: courseOnlineType,
        })
        .then(() => {
          this.isConfirmed = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-success {
  position: absolute;
  margin: 5px 10px;
  z-index: 9999;
  right: 20px;
}

.uploaded {
  background-image: url("/image/icon_check.png");
}

.drop-zone {
  height: 62px;
  background-image: none;
  background-position: none;
  background-repeat: none;
  background-size: none;
}
del {
  text-decoration-color: #dc3545;
  text-decoration-thickness: 0.1em;
}

.title-text {
  font-weight: 600;
}

.online-course-badge,
.trial-course-badge {
  font-size: 15px;
  font-weight: 400;
  border-radius: 2px;
  padding: 0 5px;
}

.online-course-badge {
  color: #2446dd;
  background-color: #f0f6fe;
  border: 1px solid #dde4fb;
}

.trial-course-badge {
  color: #814e13;
  background-color: #fefcea;
  border: 1px solid #f4e4bd;
}
</style>

<style lang="scss">
.prerequisite-courses {
  .b-form-tag-content {
    margin-bottom: 0 !important;
  }
  .close {
    font-weight: 300;
    font-size: 24px !important;
    align-self: center;
    text-shadow: none;
    line-height: 0.5 !important;
    opacity: 1;
  }
}
</style>
